// Build a readable camera label from the Wawa filename in the attachment URL.
export function deriveCameraName(url: string): string {
  const raw = url.split('/').pop() ?? '';
  let file: string;
  try {
    file = decodeURIComponent(raw);
  } catch {
    file = raw;
  }
  file = file.replace(/\.[^.]+$/, '');
  const afterRange = file.match(/TO_\d{4}-\d{2}-\d{2}_\d{2}\.\d{2}_(.+)$/);
  const label = (afterRange ? afterRange[1] : file).replace(/_/g, ' ').trim();
  return label || file || url; // never blank, even for an unexpected name shape
}

// The jobs worker uploads each thumbnail next to its video at <dir>/thumbs/<file>.jpg.
export function deriveThumbnailUrl(url: string): string {
  const slash = url.lastIndexOf('/');
  if (slash < 0) return url; // not a normal URL — let the <img> 404 into the placeholder
  const dir = url.slice(0, slash);
  const file = url.slice(slash + 1).replace(/\.[^.]+$/, '.jpg');
  return `${dir}/thumbs/${file}`;
}

// Only case videos get a thumbnail; orchid bundles don't. Keyed off the dest path our ingest writes.
export function supportsThumbnail(url: string): boolean {
  return url.includes('/wawa/cases/');
}
